<template>
    <div name="select-box-modal" class="wrapper">
        <div class="modal">
            <div class="touch" @click="onClose(selectedIndex)">

            </div>
            <div class="contents">
                <img @click="onClose(selectedIndex)" class="close-button" src="../../assets/close.png" />
                <span class="title">{{ title }}</span>
                <div style="margin-top: 30px; width: 100%;" v-if="selectList">
                    <div v-for="(select, index) in selectList" :key="index">
                        <div class="row" @click="onClose(index)" v-if="select !== ''" >
                            <span class="option-text">{{ select }}</span>
                            <img style="width: 14.29px;" v-if="selected == index" src="../../assets/selected.png" />
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'selectBoxModal',
    props: ['selectList', 'selectedIndex', 'title'],
    data: function()
    {
        return {
            selected: ''
        }
    },  
    mounted: function()
    {
        document.body.style.overflow = 'hidden'; // 스크롤 비활성화
        if(this.selectList != null)
        {
            this.selected = this.selectedIndex;
        }

        const source = document.querySelector(".contents");
        const target = document.querySelector(".touch");

        const height = source.clientHeight; // 높이 가져오기
        target.style.height = `calc(100vh - ${height}px)` // 높이 적용하기

    },
    methods: {
        onClose: function(index)
        {
            document.body.style.overflow = ''; // 스크롤 활성화
            this.$emit('closeModal', index);
        }
    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        left: 0;
        top:0;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        z-index: 99;
    }
    .modal {
        position: fixed;
        background: rgba(0, 0, 0, 0.8);
        max-width: 600px;
        width: 100%;
        height: 100vh;
        z-index: 99;
        bottom: 0;
        box-sizing: border-box;
    }
    .touch {
        width: 100vw;
    }
    .contents {
        background: #FFFFFF;
        min-height: 250px;
        max-height: 80vh;
        width: 100%;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        padding-top: 30px;
        padding-bottom: 30px;
        padding-left: 18px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        box-sizing: border-box;
        overflow-y: auto;
        position: relative;
    }
    .row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin-top: 20px;
        padding-right: 16px;
        box-sizing: border-box;
    }
    .title {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 100% */
    }
    .option-text {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 110% */
    }
    .close-button {
        position: absolute;
        right: 16px;
        top: 30px;
        cursor: pointer;
        width: 22px;
    }
</style>


// WEBPACK FOOTER //
// src/components/modals/SelectBoxModal2.vue